import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';
import styled from 'styled-components';

export const useStyles = (props: { fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      splashContainer: {
        minWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
        alignItems: 'center',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'row',
        height: '810px',
        justifyContent: 'center',
        boxShadow: '0 3px 9px 0px rgba(0, 0, 0,0.2)',
        backgroundColor: 'white',
        marginBottom: '20px',
        [theme.breakpoints.down('lg')]: {
          height: '1650px',
          flexDirection: 'column'
        },
        [theme.breakpoints.only('lg')]: {
          height: '750px',
          flexDirection: 'row'
        }
      },
      splashText: {
        fontSize: '32px',
        textAlign: 'center',
        fontFamily: props.fontFamily,
        textTransform: 'none'
      },
      splashImageBlock: {
        height: '880px',
        [theme.breakpoints.down('lg')]: {
          width: '100%',
          height: '920px'
        },
        [theme.breakpoints.only('lg')]: {
          width: '50%'
        }
      },
      splashTextBlock: {
        alignSelf: 'center',
        [theme.breakpoints.down('lg')]: {
          height: '750px',
          width: '100%'
        },
        [theme.breakpoints.only('lg')]: {
          width: '50%',
          height: 'fit-content'
        }
      },
      splashHeaderText: {
        fontSize: '64px',
        textAlign: 'center',
        fontFamily: props.fontFamily,
        fontWeight: 900,
        margin: '0px',
        [theme.breakpoints.down('lg')]: {
          padding: '10px 20px 0px 20px',
          lineHeight: 1
        }
      },
      splashImageOnly: {
        width: '1720px',
        height: '780px',
        marginBottom: '8px',
        '&>*>img': {
          height: '100%'
        },
        [theme.breakpoints.down('lg')]: {
          width: '100%',
          height: '1550px'
        },
        [theme.breakpoints.only('lg')]: {
          height: '715px'
        }
      },
      footerContainer: {
        marginTop: '20px'
      }
    })
  );

export const SplashViewImage = styled.img`
  width: 100%;
  min-height: 100%;
  background-size: cover;
`;
